import BroadcastsAPI from '../../api/broadcasts';

const state = {
  records: [],
  selected: null,
  contacts: [],
  contactsMeta: { total_count: 0, current_page: 1 },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingContacts: false,
  },
};

const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllBroadcasts(_state) {
    return _state.records;
  },
  getSelected(_state) {
    return _state.selected;
  },
  getBroadcastContacts(_state) {
    return _state.contacts;
  },
  getContactsMeta(_state) {
    return _state.contactsMeta;
  },
};

const actions = {
  async list({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await BroadcastsAPI.list(params);
      commit('SET_BROADCASTS', response.data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  // Sem try/catch: os erros do Axios propagam intactos para o
  // componente, que exibe error.response.data.error. O wrapper antigo
  // (throw new Error(error)) virava "[object Object]" e escondia a
  // mensagem real de validação do backend.

  async get({ commit }, id) {
    const response = await BroadcastsAPI.show(id);
    commit('UPDATE_BROADCAST', response.data);
    return response.data;
  },

  async create({ commit }, broadcastData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await BroadcastsAPI.create(broadcastData);
      commit('ADD_BROADCAST', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await BroadcastsAPI.update(id, updateData);
      commit('UPDATE_BROADCAST', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await BroadcastsAPI.delete(id);
      commit('REMOVE_BROADCAST', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async duplicate({ commit }, id) {
    const response = await BroadcastsAPI.duplicate(id);
    commit('ADD_BROADCAST', response.data);
    return response.data;
  },

  async pause({ commit }, id) {
    const response = await BroadcastsAPI.pause(id);
    commit('UPDATE_BROADCAST', response.data);
    return response.data;
  },

  async resume({ commit }, id) {
    const response = await BroadcastsAPI.resume(id);
    commit('UPDATE_BROADCAST', response.data);
    return response.data;
  },

  async cancel({ commit }, id) {
    const response = await BroadcastsAPI.cancel(id);
    commit('UPDATE_BROADCAST', response.data);
    return response.data;
  },
  async retryFailed({ commit }, id) {
    const response = await BroadcastsAPI.retryFailed(id);
    commit('UPDATE_BROADCAST', response.data);
    return response.data;
  },

  async contactsList({ commit }, { id, params = {} } = {}) {
    commit('SET_UI_FLAG', { isFetchingContacts: true });
    try {
      const response = await BroadcastsAPI.contacts(id, params);
      const payload = response.data;
      commit('SET_CONTACTS', payload.data || payload);
      commit('SET_CONTACTS_META', {
        total_count: payload.total_count || (payload.data || payload).length,
        current_page: params.page || 1,
      });
      return payload;
    } finally {
      commit('SET_UI_FLAG', { isFetchingContacts: false });
    }
  },

  async exportCsv(_, id) {
    return BroadcastsAPI.exportCsv(id);
  },

  setSelected({ commit }, broadcast) {
    commit('SET_SELECTED', broadcast);
  },
};

const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_BROADCASTS(_state, broadcasts) {
    _state.records = broadcasts;
  },

  ADD_BROADCAST(_state, broadcast) {
    _state.records.push(broadcast);
  },

  UPDATE_BROADCAST(_state, updatedBroadcast) {
    const index = _state.records.findIndex(r => r.id === updatedBroadcast.id);
    if (index !== -1) {
      _state.records.splice(index, 1, updatedBroadcast);
    }
    if (_state.selected && _state.selected.id === updatedBroadcast.id) {
      _state.selected = updatedBroadcast;
    }
  },

  REMOVE_BROADCAST(_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
    if (_state.selected && _state.selected.id === id) {
      _state.selected = null;
    }
  },

  SET_SELECTED(_state, broadcast) {
    _state.selected = broadcast;
  },

  SET_CONTACTS(_state, contacts) {
    _state.contacts = contacts;
  },

  SET_CONTACTS_META(_state, meta) {
    _state.contactsMeta = meta;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
